import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Box, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import BlockEditor from '../editor/BlockEditor';
import AceEditor from "react-ace";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
    useGetList, useList, useListController, ListContextProvider, Datagrid, ReferenceField, TextField, DateField,
    FunctionField, useRefresh,
} from 'react-admin';

const ProjectHistoryView = props => {
    const refresh = useRefresh();

    const { data, total, isLoading } = useGetList('report', {
        pagination: { page: 1, perPage: 10 },
        sort: { field:'reg_date', order:'DESC' },
    });

    const listContext = useList({ data, isLoading });
    
    const handleSolve = (e, record) => {
        e.stopPropagation()
        if (window.confirm('Are you sure you want to solve this exception?')) {
            client.request_post('/api/report/solve',  record)
                .then(data => {
                    refresh()
                })
                .catch(err => {
                    alert(err)
                })
        }
    }

    return (
        <TableContainer component={Paper}>
            <ListContextProvider value={listContext}>
                <Datagrid
                    rowClick={'report'} bulkActionButtons={false}>
                    <ReferenceField label="Project" source="project_id" reference="project">
                        <TextField source="name" />
                    </ReferenceField>

                    <TextField label="Screen" source="screen" />
                    <TextField label="Exception" source="exception" />
                    <TextField label="Count" source="count" />
                    <DateField label="Recent Date" source="reg_date" locales={'ko'} />

                    <FunctionField label="Solve" render={record => (
                        <Button variant="outlined"
                            onClick={(e) => {
                                handleSolve(e, record)
                            }}>
                            Solve
                        </Button>
                    )} />
                </Datagrid>
            </ListContextProvider>

        </TableContainer>
    );
};

export default ProjectHistoryView;
